import React from 'react';
import t from 'react-translate';

import ClickableContainer, { ClickableContainerProps } from 'components/clickable-container';
import NvIcon from 'shared/components/nv-icon';
import useQuestionSetHelpers from 'quizzes/hooks/use-question-set-helpers';
import { getItemBaseStyles } from '.';

type QuestionNavigatorNavigationalItemProps = {
  onClick: ClickableContainerProps['onClick'];
  next?: boolean;
  className?: string;
  disabled?: boolean;
} ;

const QuestionNavigatorNavigationalItem = (props: QuestionNavigatorNavigationalItemProps) => {
  const { className, next = false, onClick, disabled } = props;
  const {
    dataQaQuestionSetAttributes,
  } = useQuestionSetHelpers();


  return (
    <ClickableContainer
      onClick={onClick}
      disabled={disabled}
      css={getItemBaseStyles(disabled, false)}
      aria-label={next ? t.SHARED.NEXT() : t.SHARED.PREVIOUS()}
      className={`d-flex align-items-center justify-content-center ${className}`}
      data-qa={dataQaQuestionSetAttributes.questionModal[next ? 'questionNavigatorNext' : 'questionNavigatorPrevious']}
    >
      <NvIcon size='xss-smallest' icon={`arrow-${next ? 'right' : 'left'} ${disabled ? 'gray-4' : 'black'}`} />
    </ClickableContainer>
  );
};

export default QuestionNavigatorNavigationalItem;
